<div class="producer-block">
  <div class="producer-block__search">
    <input
      type="text"
      class="bm--common-search-field"
      [placeholder]="lg.producersBlock.searchProducerPlaceholder"
      (input)="searchHandler($event)"
      (keyup.enter)="getProducers()"
      [value]="producerNameSearch"
    />
  </div>

  <div class="producer-block__btn">
    <bmcore-button [title]="lg.button.search" styleName="center" (clickHandler)="getProducers()"> </bmcore-button>
  </div>
</div>

<div class="producer-block__result">
  @for (producer of producers | slice: 0 : 100; track producer) {
    <bmcore-producer-item class="producer-block__result__item" [producer]="producer"> </bmcore-producer-item>
  }
</div>

<!-- No matching results -->
@if (showNoProducersMessage) {
  <div class="producer-block__not-found">
    <bmcore-no-matching-search></bmcore-no-matching-search>
  </div>
}
